import { exchangeDelegatedEntry, type DelegatedSession } from '../../api/delegated-entry';
import { useTenantAuth } from '../../stores/auth.tenant';
import { TenantSessionChangedError } from '../../utils/tenant-session';

type SessionStore = Pick<ReturnType<typeof useTenantAuth.getState>, 'jwt' | 'commitIfCurrent' | 'setAuth'>;

export async function redeemDelegatedTicket(
  ticket: string,
  session: SessionStore,
  exchange: (ticket: string) => Promise<DelegatedSession>,
  replace: (path: string) => void,
): Promise<void> {
  const initialJwt = session.jwt;
  const result = await exchange(ticket);
  const committed = session.commitIfCurrent(initialJwt, () => {
    session.setAuth(result.jwt, result.user, result.tenant, result.has_seat, false);
  });
  if (!committed) throw new TenantSessionChangedError('Tenant session changed');
  replace('/dashboard');
}

let inFlight: Promise<void> | null = null;

export function consumeDelegatedEntry(): Promise<void> {
  if (inFlight) return inFlight;
  const ticket = new URLSearchParams(window.location.hash.slice(1)).get('ticket');
  window.history.replaceState(null, '', window.location.pathname);
  if (!ticket) return Promise.reject(new Error('缺少登录票据，请从总部重新进入'));
  inFlight = redeemDelegatedTicket(ticket, useTenantAuth.getState(), exchangeDelegatedEntry, path => window.location.replace(path));
  return inFlight;
}
